import React from 'react';
import {View} from 'react-native';
import {Info} from './ProductControls';
import {Text} from './DesignPrimitives';
import {localizedHelp} from '../shared/help-content.js';
import type {ActivityPalette} from './ActivityProfileModal';

export function HelpPanel({locale,palette}:{locale:'da-DK'|'en-GB';palette:ActivityPalette}){
 return <View style={{gap:14}}>{localizedHelp(locale).map(topic=><View key={topic.id} style={{padding:16,borderWidth:1,borderColor:palette.line,borderRadius:16,backgroundColor:palette.surface}}><Info title={topic.title} icon={topic.icon} palette={palette}><Text style={{color:palette.muted,fontSize:16,lineHeight:24}}>{topic.body}</Text></Info></View>)}</View>;
}
